// NEW_FILE_JUSTIFIED: New builder Toolbox component for left-column toolbox panel; no equivalent exists in src/components/insurance/builder/
import { TOOLBOX_FIELD_ORDER, getFieldMeta } from '@/lib/insurance/fieldTypeRegistry';
import type { TBuilderFieldType, TSectionColumns, IToolboxProps } from '@/@types/insuranceBuilder';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Columns2, Columns3, Square, Plus } from 'lucide-react';
import { toast } from 'sonner';

export function Toolbox({ hasSections, selection, lastSectionKey, dispatch }: IToolboxProps) {
  function addSection(columns: TSectionColumns) {
    dispatch({ type: 'ADD_SECTION', columns });
  }

  function addField(fieldType: TBuilderFieldType) {
    const targetSectionKey =
      selection?.kind === 'section'
        ? selection.sectionKey
        : selection?.kind === 'field'
          ? selection.sectionKey
          : lastSectionKey;

    if (!targetSectionKey) {
      toast.info('Add a section first');
      return;
    }

    dispatch({ type: 'ADD_FIELD', sectionKey: targetSectionKey, fieldType });
  }

  return (
    <ScrollArea className="h-full">
      <div className="p-3 space-y-4">
        <div>
          <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">
            Section layout
          </h3>
          <div className="grid grid-cols-3 gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => addSection(1)}
              className="h-12 flex flex-col gap-1 text-xs"
            >
              <Square className="w-4 h-4" />1 col
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => addSection(2)}
              className="h-12 flex flex-col gap-1 text-xs"
            >
              <Columns2 className="w-4 h-4" />2 col
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => addSection(3)}
              className="h-12 flex flex-col gap-1 text-xs"
            >
              <Columns3 className="w-4 h-4" />3 col
            </Button>
          </div>
        </div>

        <Separator />

        <div>
          <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">
            Field types
          </h3>
          <div className="space-y-1">
            {TOOLBOX_FIELD_ORDER.map(type => {
              const meta = getFieldMeta(type);
              const Icon = meta.icon;
              return (
                <Button
                  key={type}
                  variant="ghost"
                  className="w-full justify-start gap-2 h-9 text-sm"
                  onClick={() => addField(type)}
                  disabled={!hasSections}
                  aria-label={`Add ${meta.label} field`}
                  title={meta.description}
                >
                  <Icon className="w-4 h-4 text-muted-foreground" />
                  {meta.label}
                  <Plus className="w-3 h-3 ml-auto opacity-50" />
                </Button>
              );
            })}
          </div>
          {!hasSections && (
            <p className="text-xs text-muted-foreground mt-2">
              Add a section to start placing fields.
            </p>
          )}
        </div>
      </div>
    </ScrollArea>
  );
}
